module.exports = __webpack_public_path__ + "static/media/Portrait-10027.53baf1f5.jpg";